import { API } from "../../config/api";
import { DELETE, GET, POST } from "../../utils/apicalls";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  notification,
  Space,
  Table,
  Upload,
} from "antd";
import { useEffect, useState } from "react";
import AWS from "aws-sdk";
import { useNavigate } from "react-router-dom";
import "./bannerManagement.css";
import LoadingAnimation from "../../componets/loader/loader";



function BannerManagement() {
  interface AwsData {
    accessKeyId?: string;
    secretAccessKey?: string;
    region?: string;
    [key: string]: any;
  }
  const [awsData, setawsData] = useState<AwsData>({});
  const [form] = Form.useForm();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [data, setData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [fileUrl, setFileUrl] = useState<string | null>(null);
  const navigate = useNavigate();
  const s3 = new AWS.S3({
    accessKeyId: awsData.accessKeyId,
    secretAccessKey: awsData.secretAccessKey,
    region: awsData.region,
  });
  const fetchBanners = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.BANNER_MANAGEMENT, {});
      setData(response?.data);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchBanners();
  }, []);
  const fetchawsDetails = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.AWS_KEY, {}); // This should return the above JSON
      if (response && response.accessKeyId) {
        setawsData(response); // Not response.data
      } else if (response?.data?.accessKeyId) {
        setawsData(response.data); // If using Axios-style
      } else {
        console.warn("AWS credentials not found in response", response);
      }
    } catch (error) {
      console.error("Failed to fetch AWS credentials", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (awsData.accessKeyId && awsData.secretAccessKey && awsData.region) {
      AWS.config.update({
        accessKeyId: awsData.accessKeyId,
        secretAccessKey: awsData.secretAccessKey,
        region: awsData.region,
      });
    }
  }, [awsData]);
  useEffect(() => {
    fetchawsDetails();
  }, []);
  const S3_BUCKET = awsData?.bucketName;

  const handleFileChange = (info: any) => {
    if (info.file.status === "done") {
      const fileUrl = info.file.response?.location || info.file.response?.url; // AWS usually returns `location`
      if (fileUrl) {
        setFileUrl(fileUrl);
        form.setFieldsValue({ serviceCategory: fileUrl }); // Update form field value
      }
    } else if (info.file.status === "error") {
      notification.error({ message: "File upload failed!" });
    }
  };

  const uploadProps = {
    name: "file",
    action: `https://s3.${AWS.config.region}.amazonaws.com/${S3_BUCKET}/`,
    headers: {
      "x-amz-acl": "public-read",
      "Content-Type": "multipart/form-data",
    },
    onChange: handleFileChange,
    customRequest: async (options: any) => {
      const { onSuccess, onError, file } = options;
      const params = {
        Bucket: S3_BUCKET,
        Key: `banner/${file.name}`,
        Body: file,
        // ACL: "public-read",
        ContentType: file.type,
      };

      s3.upload(params, (err: any, data: any) => {
        if (err) {
          onError(err);
          notification.error({ message: "File upload failed!" });
        } else {
          setFileUrl(data.Location); // Set file URL on successful upload
          form.setFieldsValue({ serviceCategory: data.Location });
          onSuccess(data);
          notification.success({ message: "File uploaded successfully!" });
        }
      });
    },
  };

  // Handle form submission
  const submitHandler = async (values: any) => {
    try {
      let obj = {
        bannerTitle_one: values.bannerTitle_one,
        bannerTitle_two: values.bannerTitle_two,
        bannerSubHeading: values.bannerSubHeading,
        bannerImage: fileUrl, // Use uploaded file URL
      };

      setIsLoading(true);
      const postRequest: any = await POST(API.CREATE_BANNER, obj);
      if (postRequest?.data) {
        notification.success({ message: "Banner added successfully!" });
        // Reset form and states
        form.resetFields();
        setFileUrl(""); // Reset uploaded file state
        fetchBanners();
        setIsModalOpen(false); // Close modal
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const handleDelete = async (id: any) => {
    try {
      setIsLoading(true);
      const delete_customer_url = `${API.DELETE_BANNER}${id}`;
      const data: any = await DELETE(delete_customer_url);

      if (data.status) {
        notification.success({ message: "banner deleted successfully!" });
        fetchBanners();
      } else {
        notification.error({
          message: "Something went wrong! Please try again later.",
        });
      }
    } catch (error) {
      console.log(error);
      notification.error({
        message: "Something went wrong! Please try again later.",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const confirmDelete = (id: any) => {
    const confirm = window.confirm(
      "Are you sure you want to delete this service?"
    );
    if (confirm) {
      handleDelete(id);
    }
  };

  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      render: (_: any, __: any, index: number) => index + 1,
    },
    { title: "Banner Title One", dataIndex: "bannerTitle_one" },
    { title: "Banner Title Two", dataIndex: "bannerTitle_two" },
    {
      title: "Banner Image",
      dataIndex: "bannerImage",
      render: (url: string) => (
        <img src={url} alt="Banner" style={{ width: 100, height: 100 }} />
      ),
    },
    { title: "Banner Sub Heading", dataIndex: "bannerSubHeading" },
    {
      title: "Actions",
      key: "actions",
      render: (_: any, record: any) => (
        <Space size="middle">
          <Button type="link" onClick={() => confirmDelete(record.id)}>
            Delete
          </Button>
          <Button
            type="link"
            onClick={() =>
              navigate(`/Admin/adminBanner/updatebanner/${record.id}`)
            }
          >
            Edit
          </Button>
        </Space>
      ),
    },
  ];

  return (
    <div className="p-4 max-w-7xl mx-auto">
      <div className="banner-container">
        {isLoading ? (
          <LoadingAnimation />
        ) : (
          <div className="banner-content">
            <h1 className="banner-title">Home Page Banner</h1>
            <button
              className="banner-button"
              onClick={() => setIsModalOpen(true)}
            >
              Create Banner
            </button>
          </div>
        )}
      </div>

      <div className="w-full px-4">
        <Card className="w-full">
          {isLoading ? (
            <LoadingAnimation />
          ) : (
            <div className="overflow-x-auto">
              <Table
                columns={columns}
                dataSource={data}
                loading={isLoading}
                pagination={{ pageSize: 5 }}
                scroll={{ x: "max-content" }}
              />
            </div>
          )}
        </Card>
      </div>

      <Modal
        title="Add Banner"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
      >
        <Form form={form} onFinish={submitHandler} layout="vertical">
          <Form.Item
            name="bannerTitle_one"
            label="Banner Title One"

          >

            <Input />
          </Form.Item>
          <Form.Item
            name="bannerTitle_two"
            label="Banner Title Two"

          >

            <Input />
          </Form.Item>
          <Form.Item
            name="bannerSubHeading"
            label="Banner Sub Heading"
            rules={[
              // { required: true, message: "Please enter a banner subheading" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || value.trim().split(/\s+/).length <= 18) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Subheading must not exceed 10 words"));
                },
              }),
            ]}
          >
            <Input.TextArea autoSize={{ minRows: 2, maxRows: 4 }} />
          </Form.Item>
          <Form.Item
            name="bannerImage"
            label="Image"
            rules={[{ required: true }]}
          >
            <Upload {...uploadProps}>

              <Button className="w-full">Upload</Button>
            </Upload>
            {fileUrl && (
              <img src={fileUrl} alt="Uploaded" className="w-24 h-24 mt-2" />
            )}
          </Form.Item>
          <Button type="primary" htmlType="submit" block>

            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
}

export default BannerManagement;
